import React, { useState, useEffect } from 'react';
import Preloader from '../Preloder/Preloader';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Donate_account = () => {
  const [accounts, setAccounts] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [givendata, setGivendata] = useState({
    transactionNumber: '',
    amount: '',
  });

  const [statusMessage, setStatusMessage] = useState('');  // To store status message

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Ensure the value is numeric
    if (id === "transactionNumber" || id === "amount") {
      if (/^\d*$/.test(value)) { // This regex allows only digits
        setGivendata((prevData) => ({
          ...prevData,
          [id]: value,
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const donationData = {
      transactionNumber: givendata.transactionNumber,
      amount: givendata.amount,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/accountDonation`, donationData, {
        headers: {
          'Content-Type': 'application/json', // Use JSON content type here
        },
      });
      setStatusMessage('Donation submitted successfully!');
      setMessage('');  // Clear any previous error message
    } catch (error) {
      setStatusMessage('');
      const errorMsg = error.response?.data?.message || 'Error submitting donation';
      setMessage(errorMsg); // Display error message
    }
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/showaccountdetails/addaccount`);
        setAccounts(response.data);
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message;
        setMessage(`Error fetching data: ${errorMsg}`);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, []);

  const lastAccount = accounts.length > 0 ? accounts[accounts.length - 1] : null;

  return (
    <div>
      <Preloader />
      <Header />
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url("assets/images/backgrounds/page-header-bg-1-1.jpg")' }}></div>
        <div className="container">
          <h2 className="page-header__title">Donations by Account</h2>
          <ul className="cleenhearts-breadcrumb list-unstyled">
            <li><i className="icon-home"></i> <Link to="/">Home</Link></li>
            <li><span>Donations</span></li>
          </ul>
        </div>
      </section>

      {/* <div className='donate_qr'>
        {loading ? (
          <p>Loading...</p>
        ) : lastAccount ? (
          <div className='main_donate_account'>
            <div className='sub_donate_account'>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Account No: </span>{lastAccount.accountNumber}</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>IFSC Code: </span> {lastAccount.ifscNumber}</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Branch Name: </span> {lastAccount.branchName}</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Account Name: </span> {lastAccount.accountName}</h1>
            </div>
          </div>
        ) : (
          <p>{message || 'No account information available.'}</p>
        )}
      </div> */}
       <div className='donate_qr'>
      
         <div className='main_donate_account'>
            <div className='sub_donate_account'>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Account No: </span>254902000000189</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>IFSC Code: </span> IOBA0002549</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Branch Name: </span> Midalakadu</h1>
              <h1 style={{ color: 'yellow' }}><span style={{ color: 'white' }}>Account Name: </span>Tamil Nadu ramji education and economic development</h1>
            </div>
          </div>
      </div>


      <div className="donation_details">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            id="transactionNumber"
            placeholder="Transaction Number"
            value={givendata.transactionNumber}
            onChange={handleChange}
          />
          <input
            type="text"
            id="amount"
            placeholder="Amount"
            value={givendata.amount}
            onChange={handleChange}
          />
          <button className="button" type="submit">Submit</button>
        </form>

        {/* Displaying status or error messages here */}
        {statusMessage && <p style={{ color: 'green' }}>{statusMessage}</p>}
        {message && <p style={{ color: 'red' }}>{message}</p>}
      </div>

      <Footer />
    </div>
  );
};

export default Donate_account;
